import React, { useContext, useState } from "react";
import { InputField } from "components/common_components/Formik";
import Grid from "@material-ui/core/Grid";
import ModulesContext from "../Module/ModulesContext";
import { Field } from "formik";
import Button from "components/common_components/Button";
import { DataSearchDialog } from "components/common_components/Dialogs";
import Icon from "components/common_components/Icon";
import "./styles.scss";

function ParentInfoControl({ mode }) {
    const { getFileCasesAsync } = useContext(ModulesContext);

    function filterParentBuilder(filterValue) {
        return filterValue
            ? {
                  isQuickSearch: true,
                  quickSearchValue: filterValue,
              }
            : {};
    }

    const [searchParentDialogProps, setSearchParentDialogProps] = useState({
        open: false,
        title: "Select a file",
        onClose: () => setSearchParentDialogProps((prev) => ({ ...prev, open: false })),
        onPrimaryClick: undefined,
        onSecondaryClick: undefined,
        tableProps: {
            defaultOrder: { order: "desc", orderBy: "fileNo" },
            keyColumnName: "id",
            selectable: true,
            allowSelectAll: false,
            allowMultiSelect: false,
            dense: false,
            deletable: false,
            onRequestData: getFileCasesAsync,
            filterBuilder: filterParentBuilder,
        },
    });

    function setParent(selectedItems, { values: currentValues, setValues }) {
        const parent = selectedItems[0];

        if (parent) {
            setValues({
                ...currentValues,
                parent,
            });
        }
    }

    function searchParent(form) {
        const headCells = [
            { index: 1, id: "fileNo", disablePadding: true, label: "File #" },
            { index: 2, id: "client.lastName", disablePadding: false, label: "Last Name" },
            { index: 3, id: "client.firstName", disablePadding: false, label: "First Name" },
            { index: 4, id: "client.middleName", disablePadding: false, label: "Middle Name" },
        ];
        setSearchParentDialogProps((prev) => ({
            ...prev,
            open: true,
            onPrimaryClick: (selectedItems) => setParent(selectedItems, form),
            tableProps: {
                headCells,
                ...prev.tableProps,
            },
        }));
    }

    function cancelParent({ values: currentValues, setValues }) {
        setValues({
            ...currentValues,
            parent: {
                id: null,
                fileNo: "",
                client: {
                    firstName: "",
                    lastName: "",
                    middleName: "",
                },
            },
        });
    }

    return (
        <>
            <Grid item md={12} className="parent-info-control">
                <Grid item sm={12} md={2}>
                    <Grid container spacing={1} alignItems="center">
                        <Grid item>
                            <Field>
                                {({ _, form }) => (
                                    <>
                                        {mode !== "detail" && (
                                            <>
                                                {!form.values.parent.id && (
                                                    <Button link onClick={() => searchParent(form)}>
                                                        <Icon name="search" size="xs" color="primary" />
                                                        <span>Search parent</span>
                                                    </Button>
                                                )}
                                                {form.values.parent.id && (
                                                    <Button link onClick={() => cancelParent(form)}>
                                                        <Icon name="cancel" size="xs" color="primary" />
                                                        <span>Cancel parent</span>
                                                    </Button>
                                                )}
                                            </>
                                        )}
                                    </>
                                )}
                            </Field>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item sm={12} md={10}>
                    <Grid container spacing={1} alignItems="center">
                        <Grid item sm={12} md={6}>
                            <InputField disabled fieldName="parent.fileNo" label="Parent File No." />
                        </Grid>
                        <Grid item sm={12} md={6}>
                            <InputField disabled fieldName="parent.client.lastName" label="Parent Last Name" />
                        </Grid>
                        <Grid item sm={12} md={6}>
                            <InputField disabled fieldName="parent.client.firstName" label="Parent First Name" />
                        </Grid>
                        <Grid item sm={12} md={6}>
                            <InputField disabled fieldName="parent.client.middleName" label="Parent Middle Name" />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <DataSearchDialog {...searchParentDialogProps} />
        </>
    );
}

export default ParentInfoControl;
